import { Autocomplete, Button, CircularProgress, Divider, FormLabel, Grid, IconButton, MenuItem, Paper, Select, TextField, Tooltip, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useShoppingCartStore } from "../../../hooks/useShoppingCartStore";
import { DetailShoppingCart } from "../../../types/slices/shoppingCartType";
import { useDocumentOfSalesStore } from "../../../hooks/useDocumentOfSalesStore";
import { useTypeSaleStore } from "../../../hooks/useTypeSaleStore";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../../types";
import { useWayToPayStore } from "../../../hooks/useWayToPayStore";


import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import SaveIcon from '@mui/icons-material/Save';
import { useSaleChannelStore } from "../../../hooks/useSaleChannelStore";

interface ShoppingCartV3Props {
    handleChangeContent: (type: string) => void
    handleCloseContent: () => void
    getShoppingCartData: () => Promise<void>
    handleChangeGlobalDiscount: (idshop_cart: number, globaldiscount: number) => Promise<void>
}

export const ShoppingCartV3: FC<ShoppingCartV3Props> = (props) => {
    const { handleChangeContent, handleCloseContent, getShoppingCartData, handleChangeGlobalDiscount } = props

    const navigate = useNavigate()
    const { shoppingcart, selectedTypeDocument, selectedSaleChannel, selectedWayToPay,
        editCartProduct, deleteProductCart, setSelectedTypeDocument, setSelectedSaleChannel, setSelectedWayToPay } = useShoppingCartStore()
    const { documentOfSales, getDocumentOfSalesByCompany } = useDocumentOfSalesStore()
    // const { typesSale, getTypesSale } = useTypeSaleStore()
    const { wayToPay, getWayToPayByCompany } = useWayToPayStore()
    const { salesChannels, getSalesChannels } = useSaleChannelStore()

    const [detailShoppingCart, setDetailShoppingCart] = useState<DetailShoppingCart[]>([])

    const [timerId, setTimerId] = useState<number | null>(null);
    const [loading, setLoading] = useState<boolean>(false)
    const [editDiscount, setEditDiscount] = useState<boolean>(false)
    const [globalDiscount, setGlobalDiscount] = useState<number>(0)

    useEffect(() => {
        getCombosBoxes()
    }, [])

    useEffect(() => {
        if (shoppingcart[0] && shoppingcart[0].id) {
            setGlobalDiscount(shoppingcart[0].global_discount)
            setDetailShoppingCart(shoppingcart[0].detail)
        }
    }, [shoppingcart])

    const getCombosBoxes = async () => {
        setLoading(true)
        await getDocumentOfSalesByCompany()
        await getSalesChannels()
        await getWayToPayByCompany()
        setLoading(false)
    }

    const handleChangeQuantity = async (iddetail: number, value: string) => {
        const newQuantity = parseInt(value) > 0 ? parseInt(value) : 0
        if (newQuantity < 0) return

        let oldQuantity: number

        setDetailShoppingCart((prevDetailShoppingCart) => {
            return prevDetailShoppingCart.map((detail) => {
                if (detail.id === iddetail) {
                    oldQuantity = detail.quantity
                    return { ...detail, quantity: newQuantity }
                }
                return detail
            })
        })

        if (timerId !== null) {
            clearTimeout(timerId)
        }

        const newTimerId: any = setTimeout(async () => {
            const response = await editCartProduct(iddetail, { quantity: newQuantity })
            if (response === true) {
                getShoppingCartData()
            } else {
                setDetailShoppingCart((prevDetailShoppingCart) => {
                    return prevDetailShoppingCart.map((detail) => {
                        if (detail.id === iddetail) {
                            return { ...detail, quantity: oldQuantity }
                        }
                        return detail
                    })
                });
            }
        }, 750)

        setTimerId(newTimerId)
    }

    const handleDeleteItem = async (iddetail: number) => {
        const response = await deleteProductCart(iddetail)
        if (response === true) getShoppingCartData()
    }

    const handleVerDetallesClick = () => {
        navigate({ pathname: RoutesMap.SHOPPING_CART_V3 })
    }


    return (
        <Grid style={{ width: '80%', maxWidth: '1200px', margin: '0 auto' }}>
            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <Typography>Artículos de la cesta</Typography>
                <Tooltip title={'Cerrar panel'}>
                    <IconButton onClick={() => handleCloseContent()}>
                        <CloseIcon fontSize='medium' style={{ color: '#91CBF9' }} />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Divider />
            <Grid style={{ marginTop: '10px' }}>
                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    {detailShoppingCart.length > 0 ? (
                        <>
                            {detailShoppingCart.map((element) => (
                                <Grid item xs={12} key={element.id}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            marginBottom: '15px',
                                            border: '1px solid #ddd',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            position: 'relative',
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                                            <img
                                                style={{ width: '70px', height: '70px', margin: 'auto', marginRight: '10px' }}
                                                src={categoria_prueba}
                                                alt=""
                                            />
                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <Typography variant="subtitle2" fontWeight="bold" sx={{ textAlign: 'center', marginTop: '10px', marginBottom: '10px', marginRight: '10px', padding: '0px 5px 0px 0px' }}>
                                                    {element.name_product}
                                                </Typography>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                                    <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '14px' }}>
                                                        $ {element.price}
                                                    </Typography>
                                                    {element.discount > 0 && (
                                                        <Typography
                                                            variant="body2"
                                                            style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '0px 0px 0px 5px',
                                                                padding: '2px',
                                                                marginLeft: '5px',
                                                            }}
                                                        >
                                                            -{element.discount}%
                                                        </Typography>
                                                    )}
                                                </div>
                                                <IconButton
                                                    style={{ position: 'absolute', top: '5px', right: '5px', padding: '3px', marginLeft: 'auto' }}
                                                    onClick={() => handleDeleteItem(element.id)}
                                                >
                                                    <DeleteIcon fontSize="small" color="inherit" />
                                                </IconButton>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', width: '100%' }}>
                                            <Typography variant="body2" sx={{ marginRight: '5px' }}>
                                                Cantidad:
                                            </Typography>
                                            <TextField
                                                id="quantity"
                                                type="text"
                                                name="quantity"
                                                size="small"
                                                value={element.quantity}
                                                onChange={(e) => handleChangeQuantity(element.id, e.target.value)}
                                                inputProps={{
                                                    pattern: "[1-9]*"
                                                }}
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            ))}

                            <Grid item xs={12}>
                                <Paper sx={{ borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'whitesmoke' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" fontWeight="bold" sx={{ color: '#000000', marginBottom: '10px' }}>Resumen</Typography>
                                            <Typography sx={{ color: '#000000' }}>Puntos acumulados:</Typography>
                                            <Typography fontWeight="bolder">{''}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" sx={{ color: '#000000' }}>Total neto:</Typography>
                                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.net_total || '0'}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography sx={{ color: '#000000' }}>Descuento global:</Typography>
                                            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <TextField
                                                    id="global_discount"
                                                    type="number"
                                                    name="global_discount"
                                                    size="small"
                                                    value={globalDiscount}
                                                    onChange={(e) => {
                                                        let value = parseInt(e.target.value);
                                                        value = isNaN(value) ? 0 : Math.min(Math.max(value, 0), 100);
                                                        setGlobalDiscount(value);
                                                    }}
                                                    inputProps={{
                                                        min: 0,
                                                        max: 100,
                                                        maxLength: 3,
                                                        readOnly: !editDiscount
                                                    }}
                                                    InputProps={{
                                                        endAdornment: '%'
                                                    }}
                                                    sx={{
                                                        maxWidth: '60%'
                                                    }}
                                                />
                                                {!editDiscount
                                                    ?
                                                    <IconButton onClick={() => setEditDiscount(true)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                    :
                                                    <>
                                                        <IconButton onClick={() => {
                                                            setEditDiscount(false);
                                                            handleChangeGlobalDiscount(shoppingcart[0].id, globalDiscount)
                                                        }}>
                                                            <SaveIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton onClick={() => setEditDiscount(false)}>
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography sx={{ color: '#000000' }}>Impuestos:</Typography>
                                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.IGV || '0'}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography sx={{ color: '#000000' }}>Total bruto:</Typography>
                                            <Typography fontWeight="bolder" color="#000000">$ {shoppingcart[0]?.total || '0'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    fullWidth
                                    style={{ marginTop: '10px' }}
                                    onClick={() => handleVerDetallesClick()}
                                    sx={{
                                        background: '#91CBF9',
                                        "&:hover": {
                                            backgroundColor: "#91CBF9"
                                        }
                                    }}
                                >
                                    Ver más detalles
                                </Button>
                            </Grid>
                        </>
                    ) : (
                        <Grid item xs={12}>
                            <Grid
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '15px',
                                    border: '1px solid #ddd',
                                    padding: '10px',
                                    borderRadius: '8px',
                                }}
                            >
                                <ProductionQuantityLimitsIcon sx={{ fontSize: '50px' }} />
                                <Typography className='textbody' sx={{ color: '#3f3f3f', textAlign: 'center', fontSize: '16px' }}>
                                    Aún no tienes productos en tu canasta
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                </Grid>

                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={12}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                        <Autocomplete
                            disablePortal
                            id="combo-box-type-document"
                            value={selectedTypeDocument}
                            options={loading ? [] : documentOfSales}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            fullWidth
                            renderInput={(params) =>
                                <TextField {...params} size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            }
                            onChange={(e, newValue) => {
                                setSelectedTypeDocument(newValue);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel sx={{ color: '#000000' }}>Canal de venta:</FormLabel>
                        <Autocomplete
                            disablePortal
                            id="combo-box-sale-channel"
                            value={selectedSaleChannel}
                            options={loading ? [] : salesChannels}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            fullWidth
                            renderInput={(params) =>
                                <TextField {...params} size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            }
                            onChange={(e, newValue) => {
                                setSelectedSaleChannel(newValue);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel sx={{ color: '#000000' }}>Forma de pago:</FormLabel>
                        <Autocomplete
                            disablePortal
                            id="combo-box-way-to-pay"
                            value={selectedWayToPay}
                            options={loading ? [] : wayToPay}
                            getOptionLabel={(option) => option.wayToPay || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            fullWidth
                            renderInput={(params) =>
                                <TextField {...params} size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            }
                            onChange={(e, newValue) => {
                                setSelectedWayToPay(newValue);
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ marginTop: '10px', justifyContent: 'flex-end', marginBottom: '20px' }}>
                    <Button
                        sx={{ backgroundColor: '#91CBF9', borderRadius: '10px', color: '#ffffff', height: '25px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#91CBF9" } }}
                        onClick={() => handleChangeContent('customer')}
                        disabled={loading}
                    >
                        Continuar
                    </Button>
                </Grid>
            </Grid>
        </Grid>

    )
}